import React from 'react';
import { Link } from 'react-router-dom';
import { NewButton } from 'components/Button/NewButton/NewButton';
import { Icon, IconName } from 'components/Icon/Icon';
import { TooltipForElementNew } from 'components/Tooltips/TooltipForElementNew';

interface IProps {
	icon: IconName;
	title: string;
	to?: string;
	testId: string;
	onClick?: () => void;
}

export const ActionButton: React.FC<IProps> = ({ icon, title, to, testId, onClick }) => {
	const button = (
		<NewButton
			variant="shadow"
			size="small"
			icon={true}
			iconLeft={<Icon name={icon} size="lg" />}
			ariaLabel={title}
			testId={testId}
			onClick={onClick}
		/>
	);

	return (
		<TooltipForElementNew title={title} placement="top">
			{to ? <Link to={to}>{button}</Link> : <div>{button}</div>}
		</TooltipForElementNew>
	);
};
